export default "__VITE_ASSET__BMAAB_WD__$_?nuxt_component=async&nuxt_component_name=IOutlineCarePhoneIcon2__"